import { ticketType } from "@agentcall/core/type"
import { Select } from "@/components/ui/select"

// 型をエクスポート
export type TicketStatus = ticketType.status

// ステータスオプション
const statusOptions = ticketType.TICKET_STATUSES.map((item) => ({
  value: item.key,
  label: item.value,
}))

interface TicketStatusSelectorProps {
  /** 選択されたステータス */
  value: TicketStatus | "" | string
  /** 値変更時のコールバック */
  onChange: (value: string) => void
  /** エラーメッセージ */
  error?: string
  /** プレースホルダー */
  placeholder?: string
  /** 無効状態 */
  disabled?: boolean
  /** CSSクラス */
  className?: string
}

export function TicketStatusSelector({
  value,
  onChange,
  error,
  placeholder = "選択してください",
  disabled = false,
  className,
}: TicketStatusSelectorProps) {
  return (
    <div className={className}>
      <Select
        value={value}
        onChange={onChange}
        options={statusOptions}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
      />
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}
